import React, { memo } from 'react';

import styles from './styles/UnderlineTabMenu.module.css';

const UnderlineTabMenu = ({ tabs, activeTab, onTabChange }) => {
    if (tabs.length < 2) return null;

    return (
        <div className={styles.underlineTabMenu}>
            {tabs.map((tab) => (
                <button
                    key={tab.id}
                    className={`${styles.tab} ${activeTab === tab.id ? styles.active : ''}`}
                    onClick={() => onTabChange(tab.id)}
                >
                    <span className={styles.label}>{tab.label}</span>
                    {activeTab === tab.id && <div className={styles.underline} />}
                </button>
            ))}
        </div>
    );
};

export default memo(UnderlineTabMenu);
